import { pageRoute } from 'shared/constants/routes.constants'

type ExtractRouteParams<T extends string> = T extends `${string}[${infer Param}]${infer Rest}`
  ? Param | ExtractRouteParams<Rest>
  : never

type RouteParams<T extends string> = Record<ExtractRouteParams<T>, string | number>

type BuildRouteArgs<T extends string> = [ExtractRouteParams<T>] extends [never]
  ? []
  : [params: RouteParams<T>]

export function getPageRoute<T extends typeof pageRoute[keyof typeof pageRoute]>(
  route: T,
  ...args: BuildRouteArgs<T>
) {
  const params = args[0]

  if (!params) return route

  return route.replace(/\[([^\]]+)\]/g, (_, key: string) => {
    const value = params[key as keyof typeof params]

    if (value === undefined || value === null) {
      throw new Error(`Missing route param: ${key}`)
    }

    return String(value)
  })
}
